import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Cendres from '../views/Cendres.vue'
import DefuntNew from '../views/DefuntNew.vue'
import Archives from '../views/Archives.vue'
import Defunt from '../views/Defunt.vue'
import DefuntInfo from '../views/DefuntInfo.vue'
import Contact from '../views/Contact.vue'
import ContactEdit from '../views/ContactEdit.vue'
import ContactNew from '../views/ContactNew.vue'
import ServicesFunebres from '../views/ServicesFunebres.vue'
import ToDoRecap from '../views/ToDoRecap.vue'
import AvisMortuaire from '../views/AvisMortuaire.vue'
import Devis from '../views/Devis.vue'
import Photo from '../views/Photo.vue'
import currentUser from "../store/currentUser"

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/new',
    component: DefuntNew,
    name: 'new'
  },
  {
    path: '/archives',
    component: Archives,
    name: 'archives'
  },
  {
    path: '/cendres',
    component: Cendres,
    name: 'cendres'
  },
  {
    path: '/defunt/:id',
    component: Defunt,
    name: 'defunt',
    children: [{
        path: 'defuntInfo',
        component: DefuntInfo,
        name: 'defuntInfo'
      },
      {
        path: 'contact',
        component: Contact,
        name: 'contact'
      },
      {
        path: 'editContact/:idContact',
        component: ContactEdit,
        name: 'contactEdit'
      },
      {
        path: 'newContact',
        component: ContactNew,
        name: 'contactNew'
      },
      {
        path: 'newService',
        component: ServicesFunebres,
        name: 'servicesFunebres'
      },
      {
        path: 'avisMortuaire',
        component: AvisMortuaire,
        name: 'avisMortuaire'
      },
      {
        path: 'devis',
        component: Devis,
        name: 'devis'
      },
      {
        path: 'recap',
        component: ToDoRecap,
        name: 'recap'
      },
      {
        path: 'photo',
        component: Photo,
        name: 'photo'
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

let token = function () {
  if(localStorage.getItem('token')){
    return localStorage.getItem('token')
  }else if(sessionStorage.getItem('token')){ 
    return sessionStorage.getItem('token')
  }else{
    return false
  }
}

router.beforeEach((to, from, next) => {
  if(to.name !== 'login' && !token()){
    next({name: 'login'})
  }else{
      if(currentUser.user.id == ''){
        currentUser.setUser(token())
        console.log("Utilisateur créé dans le storage !")
      }
      next()
  }
})

export default router